import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import TableBox from "../../TableBox";
import OrganizationSelector from "../../OrganizationSelector";
import NetworksSelector from "../../NetworksSelector";
import AccountingReportSelector from "../../AccountingReportSelector";
import {
  API_URL,
  EXPORT_REPORTS_API_URL,
  GROUP_BY_FILTER_FORMATS,
  REPORTS_API_URL,
} from "../../../constants/Globals";
import DatePicker from "react-datepicker";

function ReportsAccounting({ allNetworks = [], groups = [] }) {
  const [tableData, setTableData] = useState([]);
  const [reportTableData, setReportTableData] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(() => {
    return localStorage.getItem("selectedGroupAccounting") || null;
  });
  const [selectedNetworks, setSelectedNetworks] = useState(() => {
    const savedNetworks = localStorage.getItem("selectedNetworksAccounting");
    return savedNetworks ? JSON.parse(savedNetworks) : [];
  });
  const [groupNetworks, setGroupNetworks] = useState([]);
  const [selectedReport, setSelectedReport] = useState("advertiser");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [sortByColumnMain, setSortByColumnMain] = useState("yearMonth");
  const [sortDirectionMain, setSortDirectionMain] = useState("asc");
  const [sortByColumnMonth, setSortByColumnMonth] = useState("netPercentage");
  const [sortDirectionMonth, setSortDirectionMonth] = useState("asc");
  const [tableDataTotal, setTableDataTotal] = useState({});
  const [reportsDataTotal, setReportsDataTotal] = useState({});

  useEffect(() => {
    if (selectedGroup) {
      axios
        .get(
          `${API_URL}/admin/groups/getGroupNetworks?groupId=${selectedGroup}&pageNumber=1&perPage=100&orderBy=name&order=asc`
        )
        .then(({ data }) => {
          setGroupNetworks(data.data);
        });
    }
  }, [selectedGroup]);

  useEffect(() => {
    setReportTableData([]);

    if (selectedMonth) {
      const queryParams = `?sortByColumn=${sortByColumnMonth}&sortDirection=${sortDirectionMonth}&exactMonth=${selectedMonth}&reportType=${selectedReport}&clientIds=${selectedNetworks.join(",")}&groupId=${selectedGroup || ""}`;

      axios
        .get(
          `${REPORTS_API_URL}/reports/groups/monthly-accounting-stat-summary${queryParams}`
        )
        .then(({ data }) => {
          setReportsDataTotal(data.data.allStatsSum);
          setReportTableData(data.data.rows || []);
        });
    }
  }, [
    selectedMonth,
    selectedReport,
    selectedNetworks,
    selectedGroup,
    sortByColumnMonth,
    sortDirectionMonth,
  ]);

  useEffect(() => {
    const queryParams = `?sortByColumn=${sortByColumnMain}&sortDirection=${sortDirectionMain}&clientIds=${selectedNetworks.join(",")}&groupId=${selectedGroup || ""}`;

    axios
      .get(
        `${REPORTS_API_URL}/reports/groups/accounting-stat-summary${queryParams}`
      )
      .then(({ data }) => {
        setTableDataTotal(data.data.allStatsSum);
        setTableData(data?.data?.rows || []);
      });
  }, [selectedGroup, selectedNetworks, sortByColumnMain, sortDirectionMain]);

  useEffect(() => {
    if (selectedGroup) {
      localStorage.setItem("selectedGroupAccounting", selectedGroup);
    } else {
      localStorage.removeItem("selectedGroupAccounting");
    }
  }, [selectedGroup]);

  useEffect(() => {
    if (selectedNetworks.length > 0) {
      localStorage.setItem("selectedNetworksAccounting", JSON.stringify(selectedNetworks));
    } else {
      localStorage.removeItem("selectedNetworksAccounting");
    }
  }, [selectedNetworks]);

  return (
    <>
      <div className="page-headline is-flex">
        <div>
          <strong>Reports</strong>&nbsp;|&nbsp;Accounting
        </div>
        {selectedMonth ? (
          <div>
            <DatePicker
              selected={selectedMonth}
              onChange={(date) =>
                setSelectedMonth(moment(date).format("YYYY-MM"))
              }
              dateFormat="MMMM YYYY"
              showMonthYearPicker
              showFullMonthYearPicker
              customInput={
                <div className="interval-selector">
                  <i className="fa fa-calendar"></i>
                  <input
                    type="text"
                    className="size-s"
                    value={moment(selectedMonth).format("MMMM YYYY")}
                    readOnly
                  />
                </div>
              }
            />
          </div>
        ) : null}
      </div>

      <div className="page-selectors">
        {groups?.length > 0 && (
          <OrganizationSelector
            value={selectedGroup}
            onChange={(id) => {
              setSelectedGroup(id);
              setSelectedNetworks([]);
              setGroupNetworks([]);
            }}
          />
        )}

        <NetworksSelector
          multiple={true}
          value={selectedNetworks}
          defaultText="All Networks"
          networks={selectedGroup ? groupNetworks : allNetworks}
          onChange={(ids) => setSelectedNetworks(ids)}
        />
        {selectedMonth ? (
          <AccountingReportSelector
            value={selectedReport}
            onChange={(report) => setSelectedReport(report)}
          />
        ) : null}
      </div>

      {selectedMonth && (
        <TableBox
          name = "accountingReport1"
          columnTypes={
            selectedReport === "advertiser"
              ? [
                  "Advertisers",
                  "AR Due From Adv.",
                  "AP Due To Cust.",
                  "Sided Net Revenue",
                ]
              : [
                  "Customers",
                  "Advertisers",
                  "AR Due From Adv.",
                  "Customer Share",
                  "AP Due To Cust.",
                  "Sided Net Revenue",
                  "Net %",
                ]
          }
          tableData={reportTableData}
          tableRowsTotal={reportsDataTotal}
          ageKey="stats-accounting-summary"
          sortByColumn={sortByColumnMonth}
          sortDirection={sortDirectionMonth}
          onBackClick={() => setSelectedMonth("")}
          slugify={(name) =>
            name
              .split(" ")
              .join("")
              .replace("Advertisers", "source")
              .replace("Customers", "clientName")
              .replace("Adv.", "Advertiser")
              .replace("Cust.", "Customer")
              .replace("AR", "Ar")
              .replace("AP", "Ap")
              .replace("%", "Percentage")
              .replace(/^([A-Z])|[\s_]+([a-z])/g, function ($1) {
                return $1.toLowerCase();
              })
          }
          onSortChange={(column, direction) => {
            setSortByColumnMonth(column);
            setSortDirectionMonth(direction);
          }}
          exportLink={`${EXPORT_REPORTS_API_URL}/reports/groups/monthly-accounting-stat-summary?sortByColumn=${sortByColumnMonth}&sortDirection=${sortDirectionMonth}&exactMonth=${selectedMonth}&reportType=${selectedReport}&clientIds=${selectedNetworks.join(",")}&groupId=${selectedGroup || ""}`}
        />
      )}
      {!selectedMonth && (
        <TableBox
          name="accountingReport2"
          dateFormat="MMMM Y"
          tableData={tableData}
          tableRowsTotal={tableDataTotal}
          ageKey="stats-accounting-summary"
          sortByColumn={sortByColumnMain}
          sortDirection={sortDirectionMain}
          columnTypes={[
            "Month earned",
            "Customers",
            "Advertisers",
            "AR Due From Adv.",
            "Customer Share",
            "AP Due To Cust.",
            "Sided Net Revenue",
            "Net %",
          ]}
          cellTag={(cellData, columnKey) => {
            if (columnKey === "yearMonth")
              return (
                <span
                  className="text-button"
                  onClick={() => {
                    setSelectedMonth(
                      moment(cellData[columnKey]).format("YYYY-MM")
                    );
                  }}
                >
                  {moment(cellData[columnKey].substring(0, 10)).format(
                    GROUP_BY_FILTER_FORMATS.MONTH_YEAR
                  )}
                </span>
              );
          }}
          slugify={(name) =>
            name
              .split(" ")
              .join("")
              .replace("Adv.", "Advertiser")
              .replace("Customers", "customerCount")
              .replace("Cust.", "Customer")
              .replace("AR", "Ar")
              .replace("AP", "Ap")
              .replace("%", "Percentage")
              .replace("Monthearned", "yearMonth")
              .replace(/^([A-Z])|[\s_]+([a-z])/g, function ($1) {
                return $1.toLowerCase();
              })
          }
          onSortChange={(column, direction) => {
            setSortByColumnMain(column);
            setSortDirectionMain(direction);
          }}
          exportLink={`${EXPORT_REPORTS_API_URL}/reports/groups/accounting-stat-summary?sortByColumn=${sortByColumnMain}&sortDirection=${sortDirectionMain}&clientIds=${selectedNetworks.join(",")}&groupId=${selectedGroup || ""}`}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  allNetworks: state.networks.networksList,
  groups: state.networks.groupsList,
});

export default connect(mapStateToProps, {})(ReportsAccounting);
